// {{component}}.js
import {receiveRedPacket} from "../../../api/index"
Component({
  /**
   * 组件的属性列表
   */
  properties: {
    item: {
      type: Object,
      value: {}
    },
    appId: {
      type: String,
      required: true,
      value: "",
    },
    alive_id: {
      type: String,
      required: true,
      value: "",
    },
    userId: {
      type: String,
      required: true,
      value: "",
    }
  },

  /**
   * 组件的初始数据
   */
  data: {
    ani: null,
  },
  /**
   * 组件的方法列表
   */
  methods: {
    setWxAnimation() {
      var animation = wx.createAnimation({
        duration: 500,
        timingFunction: 'linear',
      });
      animation.rotateY(180).step().rotateY(-180).step().rotateY(0).step();
      this.setData({
        ani: animation.export()
      })
    },
    openRedPacket(){
      this.setWxAnimation()
      setTimeout(()=>{
        const params = {
          app_id: this.data.appId,
          alive_id: this.data.alive_id,
          red_packet_id: this.data.item.id,
          user_id: this.data.userId,
          order_id: this.data.item.order_id
        }
        receiveRedPacket(params).then(res=>{
          res.data.data.code = res.data.code
          this.triggerEvent("receiveRedPacket",{
            resultItem: res.data.data
          })
        })
      },1500)
    },
    seeLuckList(){
      this.triggerEvent("seeLuckList",{
        backIcon: true
      })
    }
  }
})